// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ForgetPassword_inputContainer__TXxI3 {
  padding-bottom: 30px !important;
}
.ForgetPassword_ownershipQuestion__JFFl2 {
  font-size: 14px;
}
.ForgetPassword_helperText__p3g4h {
  font-size: 13px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.534);
  display: flex !important;
  align-items: center !important;
}
.ForgetPassword_ownershipInputContainer__6TSox {
  display: flex;
  align-items: center;
  column-gap: 32px;
  margin-block-start: 2px;
}
.ForgetPassword_ownershipRadioBtnContainer__UiM5I {
  display: flex;
  align-items: center;
  column-gap: 8px;
}
.ForgetPassword_ownershipRadioBtnContainer__UiM5I label {
  cursor: pointer;
}
.ForgetPassword_isActiveGrid__7vVNJ {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.ForgetPassword_trashIconGrid__SFITJ {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-inline-end: 14px;
  margin-top: -29px !important;
}
.ForgetPassword_trashContainer__7XbM7 {
  cursor: pointer;
  background-color: #fff;
}
.ForgetPassword_cardInputsGrid__Xbn9o {
  padding-inline: 50px;
}

.ForgetPassword_addCardGrid__u9DH2 {
  margin-top: -16px !important;
  padding-inline-start: 2%;
}
.ForgetPassword_addCardTxt__tnKG2 {
  padding-top: 3px;
}
.ForgetPassword_addCardButton__mZrGn {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  column-gap: 8px;
  cursor: pointer;
  width: -moz-fit-content;
  width: fit-content;
  background-color: #fff;
  padding-inline: 6px;
}
.ForgetPassword_inputGrid__BO6qw {
  padding: 15px;
}
.ForgetPassword_addCardIcon__XqW7s {
  color: #3963b8;
  fill: #3963b8;
}
.ForgetPassword_latLngInputsGrid__zYOHz {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  flex-direction: column !important;
}
.ForgetPassword_latLngInputGrid__AGDZ\\+ {
  width: 100% !important;
  flex-basis: unset !important;
}
.ForgetPassword_mapContainer__axYz2 {
  width: 90%;
  margin: auto;
  height: 350px;
}
.ForgetPassword_typesGrid__cZkZZ {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.ForgetPassword_typeAutocompleteContainer__flp9b {
  /* min-width: 250px; */
  flex-grow: 1;
  /* padding-inline-end: 16px; */
}
.ForgetPassword_chipsContainer__B3p\\+T {
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: flex-start;
  column-gap: 12px;
  flex-wrap: wrap;
  row-gap: 10px;
}
.ForgetPassword_chip__mdgPF {
  display: flex;
  align-items: center;
  justify-content: center;
  column-gap: 6px;
  padding: 6px 8px;
  border-radius: 999px;
  background-color: #3963b8;
  color: #fff;
}
.ForgetPassword_chipDeleteIcon__MFb6u {
  width: 20px !important;
  height: 20px !important;
  background-color: rgba(255, 255, 255, 0.7);
  fill: #3963b8;
  color: #3963b8;
  border-radius: 50%;
  cursor: pointer;
}
.ForgetPassword_AddressTitle__FvmKl {
  color: #000;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  padding: 40px 0 10px 0;
}
@media all and (max-width: 900px) {
  .ForgetPassword_cardInputsGrid__Xbn9o {
    padding-inline: 30px;
  }
  .ForgetPassword_addCardGrid__u9DH2 {
    padding-inline-start: 5%;
  }
}
@media all and (max-width: 700px) {
  .ForgetPassword_shareholderInputsGrid__PTeey {
    padding-inline: 40px;
  }
  .ForgetPassword_mapContainer__axYz2 {
    width: 90%;
    margin: auto;
    height: 270px;
  }
}
@media all and (max-width: 500px) {
  .ForgetPassword_shareholderInputsGrid__PTeey {
    padding-inline: 30px;
  }
  .ForgetPassword_cardInputsGrid__Xbn9o {
    padding-inline: 20px;
  }
  /* .addCardGrid {
        padding-block-start: 15px;
      } */
  .ForgetPassword_typeAutocompleteContainer__flp9b {
    min-width: 190px;
  }
}
@media all and (max-width: 350px) {
  .ForgetPassword_shareholderInputsGrid__PTeey {
    padding-inline: 20px;
  }
  .ForgetPassword_inputGrid__BO6qw {
    padding: 15px 5px;
  }
  .ForgetPassword_cardInputsGrid__Xbn9o {
    padding-inline: 15px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/DefaultPages/ForgetPassword/ForgetPassword.module.css"],"names":[],"mappings":"AAAA;EACE,+BAA+B;AACjC;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,wBAAwB;EACxB,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,wBAAwB;EACxB,4BAA4B;AAC9B;AACA;EACE,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,oBAAoB;AACtB;;AAEA;EACE,4BAA4B;EAC5B,wBAAwB;AAC1B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,eAAe;EACf,eAAe;EACf,uBAAkB;EAAlB,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;EACd,aAAa;AACf;AACA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,iCAAiC;AACnC;AACA;EACE,sBAAsB;EACtB,4BAA4B;AAC9B;AACA;EACE,UAAU;EACV,YAAY;EACZ,aAAa;AACf;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,eAAe;AACjB;AACA;EACE,sBAAsB;EACtB,YAAY;EACZ,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;EACf,aAAa;AACf;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,0CAA0C;EAC1C,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE;IACE,oBAAoB;EACtB;EACA;IACE,wBAAwB;EAC1B;AACF;AACA;EACE;IACE,oBAAoB;EACtB;EACA;IACE,UAAU;IACV,YAAY;IACZ,aAAa;EACf;AACF;AACA;EACE;IACE,oBAAoB;EACtB;EACA;IACE,oBAAoB;EACtB;EACA;;SAEO;EACP;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,oBAAoB;EACtB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,oBAAoB;EACtB;AACF","sourcesContent":[".inputContainer {\r\n  padding-bottom: 30px !important;\r\n}\r\n.ownershipQuestion {\r\n  font-size: 14px;\r\n}\r\n.helperText {\r\n  font-size: 13px;\r\n  font-weight: 500;\r\n  color: rgba(0, 0, 0, 0.534);\r\n  display: flex !important;\r\n  align-items: center !important;\r\n}\r\n.ownershipInputContainer {\r\n  display: flex;\r\n  align-items: center;\r\n  column-gap: 32px;\r\n  margin-block-start: 2px;\r\n}\r\n.ownershipRadioBtnContainer {\r\n  display: flex;\r\n  align-items: center;\r\n  column-gap: 8px;\r\n}\r\n.ownershipRadioBtnContainer label {\r\n  cursor: pointer;\r\n}\r\n.isActiveGrid {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: flex-start;\r\n}\r\n.trashIconGrid {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: flex-end;\r\n  padding-inline-end: 14px;\r\n  margin-top: -29px !important;\r\n}\r\n.trashContainer {\r\n  cursor: pointer;\r\n  background-color: #fff;\r\n}\r\n.cardInputsGrid {\r\n  padding-inline: 50px;\r\n}\r\n\r\n.addCardGrid {\r\n  margin-top: -16px !important;\r\n  padding-inline-start: 2%;\r\n}\r\n.addCardTxt {\r\n  padding-top: 3px;\r\n}\r\n.addCardButton {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: flex-start;\r\n  column-gap: 8px;\r\n  cursor: pointer;\r\n  width: fit-content;\r\n  background-color: #fff;\r\n  padding-inline: 6px;\r\n}\r\n.inputGrid {\r\n  padding: 15px;\r\n}\r\n.addCardIcon {\r\n  color: #3963b8;\r\n  fill: #3963b8;\r\n}\r\n.latLngInputsGrid {\r\n  display: flex !important;\r\n  align-items: center !important;\r\n  justify-content: center !important;\r\n  flex-direction: column !important;\r\n}\r\n.latLngInputGrid {\r\n  width: 100% !important;\r\n  flex-basis: unset !important;\r\n}\r\n.mapContainer {\r\n  width: 90%;\r\n  margin: auto;\r\n  height: 350px;\r\n}\r\n.typesGrid {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: flex-start;\r\n  flex-wrap: wrap;\r\n}\r\n.typeAutocompleteContainer {\r\n  /* min-width: 250px; */\r\n  flex-grow: 1;\r\n  /* padding-inline-end: 16px; */\r\n}\r\n.chipsContainer {\r\n  display: flex;\r\n  align-items: center;\r\n  flex-direction: row;\r\n  justify-content: flex-start;\r\n  column-gap: 12px;\r\n  flex-wrap: wrap;\r\n  row-gap: 10px;\r\n}\r\n.chip {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  column-gap: 6px;\r\n  padding: 6px 8px;\r\n  border-radius: 999px;\r\n  background-color: #3963b8;\r\n  color: #fff;\r\n}\r\n.chipDeleteIcon {\r\n  width: 20px !important;\r\n  height: 20px !important;\r\n  background-color: rgba(255, 255, 255, 0.7);\r\n  fill: #3963b8;\r\n  color: #3963b8;\r\n  border-radius: 50%;\r\n  cursor: pointer;\r\n}\r\n.AddressTitle {\r\n  color: #000;\r\n  font-size: 20px;\r\n  font-style: normal;\r\n  font-weight: 700;\r\n  line-height: normal;\r\n  padding: 40px 0 10px 0;\r\n}\r\n@media all and (max-width: 900px) {\r\n  .cardInputsGrid {\r\n    padding-inline: 30px;\r\n  }\r\n  .addCardGrid {\r\n    padding-inline-start: 5%;\r\n  }\r\n}\r\n@media all and (max-width: 700px) {\r\n  .shareholderInputsGrid {\r\n    padding-inline: 40px;\r\n  }\r\n  .mapContainer {\r\n    width: 90%;\r\n    margin: auto;\r\n    height: 270px;\r\n  }\r\n}\r\n@media all and (max-width: 500px) {\r\n  .shareholderInputsGrid {\r\n    padding-inline: 30px;\r\n  }\r\n  .cardInputsGrid {\r\n    padding-inline: 20px;\r\n  }\r\n  /* .addCardGrid {\r\n        padding-block-start: 15px;\r\n      } */\r\n  .typeAutocompleteContainer {\r\n    min-width: 190px;\r\n  }\r\n}\r\n@media all and (max-width: 350px) {\r\n  .shareholderInputsGrid {\r\n    padding-inline: 20px;\r\n  }\r\n  .inputGrid {\r\n    padding: 15px 5px;\r\n  }\r\n  .cardInputsGrid {\r\n    padding-inline: 15px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"inputContainer": `ForgetPassword_inputContainer__TXxI3`,
	"ownershipQuestion": `ForgetPassword_ownershipQuestion__JFFl2`,
	"helperText": `ForgetPassword_helperText__p3g4h`,
	"ownershipInputContainer": `ForgetPassword_ownershipInputContainer__6TSox`,
	"ownershipRadioBtnContainer": `ForgetPassword_ownershipRadioBtnContainer__UiM5I`,
	"isActiveGrid": `ForgetPassword_isActiveGrid__7vVNJ`,
	"trashIconGrid": `ForgetPassword_trashIconGrid__SFITJ`,
	"trashContainer": `ForgetPassword_trashContainer__7XbM7`,
	"cardInputsGrid": `ForgetPassword_cardInputsGrid__Xbn9o`,
	"addCardGrid": `ForgetPassword_addCardGrid__u9DH2`,
	"addCardTxt": `ForgetPassword_addCardTxt__tnKG2`,
	"addCardButton": `ForgetPassword_addCardButton__mZrGn`,
	"inputGrid": `ForgetPassword_inputGrid__BO6qw`,
	"addCardIcon": `ForgetPassword_addCardIcon__XqW7s`,
	"latLngInputsGrid": `ForgetPassword_latLngInputsGrid__zYOHz`,
	"latLngInputGrid": `ForgetPassword_latLngInputGrid__AGDZ+`,
	"mapContainer": `ForgetPassword_mapContainer__axYz2`,
	"typesGrid": `ForgetPassword_typesGrid__cZkZZ`,
	"typeAutocompleteContainer": `ForgetPassword_typeAutocompleteContainer__flp9b`,
	"chipsContainer": `ForgetPassword_chipsContainer__B3p+T`,
	"chip": `ForgetPassword_chip__mdgPF`,
	"chipDeleteIcon": `ForgetPassword_chipDeleteIcon__MFb6u`,
	"AddressTitle": `ForgetPassword_AddressTitle__FvmKl`,
	"shareholderInputsGrid": `ForgetPassword_shareholderInputsGrid__PTeey`
};
export default ___CSS_LOADER_EXPORT___;
